import CandidateVideoTileGrid from '@fragments/CandidateVideoTileGrid';
import { VideoTileGridProvider } from '@providers/VideoTileGridProvider';
import type { FC } from 'react';
import { Container } from './style';

const Video: FC = () => {
  return (
    <Container>
      <VideoTileGridProvider>
        <CandidateVideoTileGrid className='videos' />
      </VideoTileGridProvider>
    </Container>
  );
};

export default Video;
